import { Component, HostBinding, Input } from "@angular/core";

function transformType(value: string | undefined): string {
  return value == null ? "button" : String(value);
}

@Component({
  // We use the [vw] as our selector in this
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: "button[vw]",
  templateUrl: "./button-bare.component.html",
  host: {
    class: "btn",
  },
})
export class ButtonBareComponent {
  @Input() set vw(_: undefined) {}
  @HostBinding("class.btn-primary") @Input() primary?: boolean;
  @HostBinding("class.btn-light") @Input() light?: boolean;
  @HostBinding("attr.type")
  @Input({ transform: transformType })
  type: string = "button";
  @HostBinding("disabled") @Input() disabled?: boolean;
  @HostBinding("class.btn-lg") @Input() large?: boolean;
  @HostBinding("class.btn-sm") @Input() small?: boolean;
  @HostBinding("class.vw-rounded") @Input() rounded?: boolean;
  @HostBinding("class.vw-border") @Input() border?: boolean;
  @Input() icon?: string;

  constructor() {}
}

export class BareButtonComponent {}
